export const icons = new Set([
  "abcjavascriptrenderer",
  "actionscript",
  "adlibsoftware",
  "adobeaftereffects",
  "adobeillustrator",
  "adobeindesign",
  "adobephotoshop",
  "adobepremierepro",
  "akkatoolkit",
  "amazonwebservices",
  "americanstandardcodeforinformationinterchangeascii",
  "anaconda",
  "androiddebugbridge",
  "androidndk",
  "androidsoftware",
  "androidsoftwaredevelopment",
  "androidstudio",
  "androidui",
  "angular2",
  "angularjs",
  "angularmaterial",
  "angularui",
  "ansible",
  "apache",
  "apacheaccumulo",
  "apacheactivemq",
  "apacheant",
  "apachebeam",
  "apachecamel",
  "apachecassandra",
  "apachecloudstack",
  "apachecocoon",
  "apachecommons",
  "apachecordova",
  "apachecxf",
  "apachefelix",
  "apacheflex",
  "apacheflink",
  "apacheflume",
  "apachefop",
  "apachegump",
  "apachehadoop",
  "apachehbase",
  "apachehive",
  "apachehttpserver",
  "apachehypertexttransferprotocolserver",
  "apacheibatis",
  "apachejmeter",
  "apachekafka",
  "apachekaraf",
  "apachelucene",
  "apachemaven",
  "apachenifi",
  "apacheoozie",
  "apacheopenoffice",
  "apachepig",
  "apachepoi",
  "apacheservicemix",
  "apachesolr",
  "apachespark",
  "apachestorm",
  "apachestruts",
  "apachetomcat",
  "apachetorque",
  "apacheturbine",
  "apachewicket",
  "apacheyarn",
  "apachezookeeper",
  "apexcode",
  "apexprogramming",
  "apidesign",
  "apimanagement",
  "appcelerator",
  "apple",
  "appleios",
  "appleipod",
  "applemacsystems",
  "applemaps",
  "appleproducts",
  "applepushnotificationservice",
  "appleremotedesktop",
  "applescriptscriptinglanguage",
  "appletv",
  "applewatch",
  "applexcode",
  "appstoreios",
  "arduino",
  "armarchitecture",
  "artisansoftware",
  "aspectorientedprogramming",
  "aspnet",
  "aspnetapplications",
  "aspnetextensionsforajax",
  "aspnetmvcframework",
  "aspnetwebapi",
  "aspnetwebforms",
  "assemblylanguage",
  "audio",
  "audiocodec",
  "audioeditingsoftware",
  "audiosignalprocessing",
  "audiostreaming",
  "audiovideodistribution",
  "aurelia",
  "autodesk3dsmax3dgraphicssoftware",
  "avro",
  "awkprogramminglanguage",
  "azureservicefabric",
  "backbonejs",
  "backupandrestore",
  "backupdevices",
  "backupreplication",
  "bashshell",
  "behat",
  "bicep",
  "binaryspacepartitioning",
  "bitbucket",
  "bitcoin",
  "bootstrapsoftware",
  "bower",
  "browsercompatibility",
  "bugtrackingsystems",
  "buildtools",
  "bundler",
  "cakephp",
  "cascadingstylesheetscss",
  "chromecast",
  "chromeos",
  "circleci",
  "cleancodeprinciples",
  "clojure",
  "cloudfoundry",
  "cmake",
  "cobolprogramminglanguage",
  "cocoapods",
  "coda",
  "codecomposerstudio",
  "codecoverage",
  "coffeescript",
  "comprehensiveperlarchivenetworkcpan",
  "computerfonts",
  "confluence",
  "coq",
  "coreldrawcorelsoftware",
  "cosmosdb",
  "cpp",
  "cprogramminglanguage",
  "csharpprogramminglanguage",
  "cucumberjvm",
  "cucumbersoftware",
  "curl",
  "d3js",
  "dart",
  "databasebackup",
  "datanormalization",
  "datapipelines",
  "dbase",
  "debianlinux",
  "deliverypipeline",
  "delphiprogramminglanguage",
  "digitalarchives",
  "digitalaudioplayer",
  "docker",
  "dockerforaws",
  "dockerswarm",
  "dojotoolkit",
  "domainnamesystemdns",
  "doxygen",
  "drools",
  "drupal",
  "dyalogapl",
  "eagleprogram",
  "eclipsesoftware",
  "elasticsearch",
  "electronprogramminglanguage",
  "elixir",
  "emacs",
  "emailfiltering",
  "emailmanagement",
  "emailnotifications",
  "emailproduction",
  "emberjs",
  "enterprisejavabeans",
  "erlang",
  "eslint",
  "expoio",
  "extjs",
  "fiddlersoftware",
  "figma",
  "filearchiver",
  "firebase",
  "firefox",
  "fitbit",
  "flaskwebframework",
  "flutter",
  "formhtml",
  "fortranprogramminglanguage",
  "foxpro",
  "freemarker",
  "galenframework",
  "gaugesoftware",
  "git",
  "gitflow",
  "github",
  "githubenterprise",
  "gitlab",
  "glasgowhaskellcompiler",
  "gnucompilercollection",
  "gnudebuggers",
  "gnugeneralpubliclicense",
  "gnuimagemanipulationprogramgimp",
  "gnulinker",
  "gnuoperatingsystem",
  "gnuscientificlibrary",
  "golang",
  "googlechrome",
  "googlecloud",
  "gradle",
  "graphql",
  "groovy",
  "gruntsoftware",
  "gulpjs",
  "heroku",
  "homeautomation",
  "houdinisoftware",
  "hpalm",
  "hpapplicationlifecyclemanagement",
  "hpbladesystems",
  "hpservers",
  "html",
  "hyperspectralimaging",
  "idris",
  "influxdb",
  "informix",
  "inkscape",
  "ionic",
  "isabelle",
  "jasmine",
  "javaprogramminglanguage",
  "javascriptbuild",
  "javascriptlibraries",
  "javascriptprogramminglanguage",
  "jenkins",
  "jira",
  "joomla",
  "jquery",
  "json",
  "jsonwebtoken",
  "julia",
  "junos",
  "jupyter",
  "knime",
  "knockoutjs",
  "kotlin",
  "kubernetes",
  "labview",
  "laravel",
  "linuxservers",
  "liquibase",
  "lispprogramminglanguage",
  "lookeranalytics",
  "luascriptinglanguage",
  "magento",
  "makesoftware",
  "markdown",
  "markuplanguages",
  "mathematica",
  "mathematicalprogramming",
  "matlab",
  "maya",
  "mercurial",
  "meteor",
  "microsoftaccess",
  "microsoftazure",
  "microsoftexcel",
  "microsoftonenote",
  "microsoftoutlook",
  "microsoftpowerpoint",
  "microsoftproject",
  "microsoftpublisher",
  "microsoftvisualstudio",
  "microsoftwindows",
  "microsoftword",
  "minecraft",
  "mocha",
  "molecularmodeling",
  "mongodb",
  "mootools",
  "mprogramminglanguage",
  "mustache",
  "mybatis",
  "mysql",
  "mysql5",
  "nant",
  "neo4j",
  "netcore",
  "netframework",
  "netframework4",
  "nessus",
  "nestjs",
  "newrelic",
  "newrelicsaas",
  "nextjs",
  "nginx",
  "nimprogramminglanguage",
  "nmap",
  "nodejs",
  "npmsoftware",
  "nuget",
  "numpy",
  "nvidiacuda",
  "objectorientedjavascript",
  "octave",
  "omnigraffle",
  "openapi",
  "openbsd",
  "opencl",
  "opengl",
  "openglshadinglanguage",
  "openshift",
  "openstack",
  "openvpn",
  "oracleapplications",
  "oraclecloudinfrastructure",
  "parquet",
  "pascalprogramminglanguage",
  "perlprogramminglanguage",
  "phpdevelopment",
  "phpframeworks",
  "phpprogramminglanguage",
  "phpunit",
  "playframework",
  "playwright",
  "postgresql",
  "powerbuilder",
  "powerpc",
  "prolog",
  "prometheus",
  "protocolbuffers",
  "protractor",
  "proxyservers",
  "puppet",
  "pythonprogramminglanguage",
  "qliksense",
  "qlikview",
  "qtmodelinglanguageqml",
  "qtsoftware",
  "reactjs",
  "reactnative",
  "reactredux",
  "redhatenterpriselinux",
  "redis",
  "remotebackupservices",
  "requirejs",
  "restfulapimodelinglanguage",
  "reverseproxy",
  "rexxprogramminglanguage",
  "rhinoceros3d",
  "richsitesummaryrss",
  "roblox",
  "roboticautomationsoftware",
  "robotoperatingsystem",
  "rollup",
  "rspec",
  "rstudio",
  "ruby",
  "rubyonrails",
  "rustprogramminglanguage",
  "rxjs",
  "safariwebbrowser",
  "sapabap",
  "schemeprogramminglanguage",
  "senchatouch",
  "sentry",
  "serverlesscomputing",
  "shellscript",
  "shopify",
  "sketchup",
  "sketchup3dmodelingsoftware",
  "smartsheet",
  "snapsoftware",
  "snortsoftware",
  "socialbookmarking",
  "solidity",
  "sonarqube",
  "sonarsymantec",
  "sparql",
  "springboot",
  "springmvc",
  "sqlite",
  "squarespace",
  "stata",
  "storageareanetworksan",
  "surveymonkey",
  "suselinux",
  "suselinuxenterpriseservers",
  "svelte",
  "swagger",
  "swiftprogramminglanguage",
  "symfony",
  "symphony",
  "tailwind",
  "tclprogramminglanguage",
  "ternjs",
  "terraform",
  "testingsoftware",
  "travisci",
  "typescript",
  "typo3",
  "uikit",
  "uml",
  "unittesting",
  "unity3d",
  "unixshell",
  "unrealengine",
  "vagrant",
  "verilog",
  "virtualmachines",
  "visualbasicnetprogramminglanguage",
  "visualstudioonline",
  "vmware",
  "vuejs",
  "watchman",
  "webgl",
  "webpack",
  "windowspowershell",
  "wix",
  "wordpress",
  "xamarin",
  "xmlschema",
  "xquery",
  "yahoouserinterfacelibraryyui",
  "yaml",
  "yiiphpframework",
  "zbrush",
]);
